const betaURL = require("app/util/config/beta-url");
const _ = require("underscore");
const Reflux = require("reflux");

const UserAvatar = require("app/shared/components/User/user-avatar");
const Tooltip = require("app/shared/components/Tooltip/tooltip");
const Icon = require("app/shared/components/Icon/icon");
const config = require("app/util/config/config");

const currencyFormatter = require("app/util/formatter/currency");
const textFormatter = require("app/util/formatter/text");

const TOTAL_ROW_ID = 0;

const FunnelMovesTable = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getDetailsUrl: function(ownerId, move, status) {
    let dateFormat = "YYYY-MM-DD";
    let formattedStartDate = this.props.period.startDate.format(dateFormat);
    let formattedEndDate = this.props.period.endDate.format(dateFormat);

    var originFunnelId = this.props.originFunnel.id;
    var destinationFunnelId = this.props.destinationFunnel.id;

    let searchParams = new URLSearchParams();

    searchParams.append("qpp", 25);
    searchParams.append("dii", formattedStartDate);
    searchParams.append("dif", formattedEndDate);
    searchParams.append("fi", originFunnelId);

    if (move !== "started") {
      searchParams.append("funil", destinationFunnelId);
    }

    if (status === "won") {
      searchParams.append("sn", 2);
    } else if (status === "lost") {
      searchParams.append("sn", 3);
    }

    if (ownerId !== TOTAL_ROW_ID) {
      searchParams.append("u", ownerId);
    }

    return `${betaURL()}/deals?${searchParams}`;
  },

  formatValue: function(value) {
    if (value) {
      return currencyFormatter.formatCentsToCurrency(value);
    } else {
      return "R$ 0,00";
    }
  },

  formatPercentage: function(value) {
    if (value) {
      return textFormatter.formatValuePercentage(value);
    } else {
      return "0%";
    }
  },

  funnelMoves: function() {
    let users_funnel_moves = _.map(this.props.data.users, function(user) {
      return this.userRow(user);
    }.bind(this));

    let total_funnel_moves = this.totalRow(this.props.data.total);

    let tableBody = [...users_funnel_moves, total_funnel_moves];

    return (
      <div className="h-280 ovy-auto thinScrollbar">
        <table className='table table-striped w-100pct c-black mb-0 ta-c'>
          <thead>
            <tr>
              <th scope="col" className="bb-n th-fixed bg-white">
                <div className="fw-500 ta-c fs-11 tt-upper">
                  usuários
                </div>
              </th>
              <th scope="col" className="bb-n th-fixed bg-white">
                <div className="fw-500 ta-c fs-11 tt-upper">
                  iniciados
                </div>
              </th>
              <th scope="col" className="bb-n th-fixed bg-white"></th>
              <th scope="col" className="bb-n th-fixed bg-white">
                <div className="fw-500 ta-c fs-11 tt-upper">
                  movidos
                </div>
              </th>
              <th scope="col" className="bb-n th-fixed bg-white"></th>
              <th scope="col" className="bb-n th-fixed bg-white">
                <div className="fw-500 ta-c fs-11 tt-upper c-fontGreen">
                  ganhos
                </div>
              </th>
              <th scope="col" className="bb-n th-fixed bg-white">
                <div className="fw-500 ta-c fs-11 tt-upper c-primaryRed">
                  perdidos
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            {tableBody}
          </tbody>
        </table>
      </div>
    );
  },

  userRow: function(data) {
    var { user } = data;

    var extraProps = {
      className: "",
      userColumn: (
        <td className="ta-c">
          <UserAvatar
            name={user.name}
            size="small"
            avatarURL={`${config.app.apiRailsURL}/users/${user.id}/avatar`}
          />
          <span className="d-b fs-11">{user.name}</span>
        </td>
      ),
      valueColumnClass: "c-lightGrey",
      percentageColumnClass: "c-darkBlue"
    };

    return this.row(data, extraProps);
  },

  totalRow: function(data) {
    var user = { id: TOTAL_ROW_ID, name: "Total" };

    var extraProps = {
      className: "bg-opaqueGray",
      userColumn: (
        <td className="ta-c">
          <span className="mt-15 d-b fs-12 fw-500 tt-upper">{user.name}</span>
        </td>
      ),
      valueColumnClass: "",
      percentageColumnClass: ""
    };

    return this.row(Object.assign({}, data, { user: user }), extraProps);
  },

  row: function(data, extraProps) {
    var { user, started, moved, won, lost } = data;

    return (
      <tr scope="row" key={user.id} className={`h-60 ${extraProps.className}`}>
        {extraProps.userColumn}
        <td className={extraProps.valueColumnClass}>
          <a className="seamless-link" target="_blank" href={this.getDetailsUrl(user.id, "started")}>
            <Tooltip html bottom
              title={this.startedTooltip(user.name, started.count)}
              color="darker"
              container="#funnel-moves-tooltip-container"
            >
              <div className="mt-5">
                <span className="d-b fs-14 fw-500">
                  {started.count || 0}
                </span>
                <span className="d-b fs-12">
                  {this.formatValue(started.total_amount)}
                </span>
              </div>
            </Tooltip>
          </a>
        </td>
        <td className={extraProps.percentageColumnClass}>
          <Tooltip html bottom
            title={this.movedPercentageTooltip(
              user.name, started.count, moved.count, moved.percentage
            )}
            color="darker"
            container="#funnel-moves-tooltip-container"
          >
            <div className="mt-10 mb-5">
              <div className="fs-12">
                {this.formatPercentage(moved.percentage)}
              </div>
              <Icon custom icon="long-arrow-right" className="fs-12 lh-0 pe-none" />
            </div>
          </Tooltip>
        </td>
        <td className={extraProps.valueColumnClass}>
          <a className="seamless-link" target="_blank" href={this.getDetailsUrl(user.id, "moved")}>
            <Tooltip html bottom
              title={this.movedTooltip(user.name, started.count, moved.count)}
              color="darker"
              container="#funnel-moves-tooltip-container"
            >
              <div className="mt-5">
                <div className="fs-14 fw-500">
                  {moved.count || 0}
                </div>
                <div className="fs-12">
                  {this.formatValue(moved.total_amount)}
                </div>
              </div>
            </Tooltip>
          </a>
        </td>
        <td className={extraProps.percentageColumnClass}>
          <Tooltip html bottom
            title={this.wonPercentageTooltip(user.name, moved.count, won.count, won.percentage)}
            color="darker"
            container="#funnel-moves-tooltip-container"
          >
            <div className="mt-10 mb-5">
              <div className="fs-12">
                {this.formatPercentage(won.percentage)}
              </div>
              <Icon custom icon="long-arrow-right" className="fs-12 lh-0 pe-none" />
            </div>
          </Tooltip>
        </td>
        <td className={extraProps.valueColumnClass}>
          <a className="seamless-link" target="_blank" href={this.getDetailsUrl(user.id, "finished", "won")}>
            <Tooltip html bottom
              title={this.finishedTooltip(user.name, moved.count, won.count, "ganhos")}
              color="darker"
              container="#funnel-moves-tooltip-container"
            >
              <div className="mt-5">
                <div className="fs-14 fw-500">
                  {won.count || 0 }
                </div>
                <div className="fs-12">
                  {this.formatValue(won.total_amount)}
                </div>
              </div>
            </Tooltip>
          </a>
        </td>
        <td className={extraProps.valueColumnClass}>
          <a className="seamless-link" target="_blank" href={this.getDetailsUrl(user.id, "finished", "lost")}>
            <Tooltip html bottom
              title={this.finishedTooltip(user.name, moved.count, lost.count, "perdidos")}
              color="darker"
              container="#funnel-moves-tooltip-container"
            >
              <div className="mt-5">
                <div className="fs-14 fw-500">
                  {lost.count || 0}
                </div>
                <div className="fs-12">
                  {this.formatValue(lost.total_amount)}
                </div>
              </div>
            </Tooltip>
          </a>
        </td>
      </tr>
    );
  },

  startedTooltip: function(userName, startedCount) {
    var startDate = moment(this.props.period.startDate).format("DD MMM, YYYY");
    var endDate = moment(this.props.period.endDate).format("DD MMM, YYYY");
    var originFunnel = this.props.originFunnel.name;
    var parsedStartedCount = startedCount || 0;

    return `<b>${userName}</b>\n\n<b>${parsedStartedCount}</b> negócios iniciados ` +
      `no ${originFunnel} em ${startDate} - ${endDate}`;
  },

  movedPercentageTooltip: function(userName, startedCount, movedCount, movedPercentage) {
    var originFunnel = this.props.originFunnel.name;
    var destinationFunnel = this.props.destinationFunnel.name;
    var parsedStartedCount = startedCount || 0;
    var parsedMovedCount = movedCount || 0;
    var formattedMovedPercentage = this.formatPercentage(movedPercentage);

    return `<b>${userName}</b>\n\nDos <b>${parsedStartedCount}</b> negócios iniciados ` +
      `no ${originFunnel}, <b>${formattedMovedPercentage}</b> foram movidos para o ` +
      `${destinationFunnel}\n\nFórmula do cálculo: ${parsedMovedCount} / ${parsedStartedCount}`;
  },

  movedTooltip: function(userName, startedCount, movedCount) {
    var originFunnel = this.props.originFunnel.name;
    var destinationFunnel = this.props.destinationFunnel.name;
    var parsedStartedCount = startedCount || 0;
    var parsedMovedCount = movedCount || 0;

    return `<b>${userName}</b>\n\nDos <b>${parsedStartedCount}</b> negócios iniciados no ` +
      `${originFunnel}, <b>${parsedMovedCount}</b> foram movidos para o ${destinationFunnel}`;
  },

  wonPercentageTooltip: function(userName, movedCount, wonCount, wonPercentage) {
    var destinationFunnel = this.props.destinationFunnel.name;
    var parsedMovedCount = movedCount || 0;
    var parsedWonCount = wonCount || 0;
    var formattedWonPercentage = this.formatPercentage(wonPercentage);

    return `<b>${userName}</b>\n\nDos <b>${parsedMovedCount}</b> negócios movidos para o ` +
      `${destinationFunnel}, <b>${formattedWonPercentage}</b> foram ganhos\n\n` +
      `Fórmula do cálculo: ${parsedWonCount} / ${parsedMovedCount}`;
  },

  finishedTooltip: function(userName, movedCount, finishedCount, type) {
    var destinationFunnel = this.props.destinationFunnel.name;
    var parsedMovedCount = movedCount || 0;
    var parsedFinishedCount = finishedCount || 0;

    return `<b>${userName}</b>\n\nDos <b>${parsedMovedCount}</b> negócios movidos para o ` +
      `${destinationFunnel}, <b>${parsedFinishedCount}</b> foram ${type}`;
  },

  isEmptyData: function() {
    return this.props.data.users.length === 0;
  },

  emptyDataMessage: function() {
    let funnelName = this.props.originFunnel.name;

    return (
      <div className='h-280 c-normalGrey flex-column d-f jc-center align-center'>
        <div>
          {`Não há informações de negócios iniciados no ${funnelName} para o período selecionado`}
        </div>
      </div>
    );
  },

  multipleFunnelsRequiredMessage: function() {
    let newFunnelURL = betaURL() + '/funnels';

    return (
      <div className='h-280 c-normalGrey flex-column d-f jc-center align-center'>
        <div className='mb-30'>
          Sua conta precisa ter múltiplos funis para poder exibir esse relatório
        </div>

        <div>
          <a href={newFunnelURL}>
            Criar um novo funil
          </a>
        </div>
      </div>
    );
  },

  noData: function() {
    return (
      <div className='h-280'></div>
    );
  },

  isSameFunnel: function() {
    if (!this.props.originFunnel || !this.props.destinationFunnel) {
      return false;
    }

    return this.props.originFunnel.id === this.props.destinationFunnel.id;
  },

  sameFunnelsRequestedMessage: function() {
    return (
      <div className='h-280 c-vividOrange flex-column d-f jc-center align-center'>
        <div className='mb-30 fs-32'>
          <Icon icon='alert' />
        </div>

        <div>
          Selecione dois funis diferentes para visualizar o relatório
        </div>
      </div>
    );
  },

  render: function() {
    if (!this.props.hasMultipleFunnels) {
      return this.multipleFunnelsRequiredMessage();
    } else if (this.isSameFunnel()) {
      return this.sameFunnelsRequestedMessage();
    } else if (!this.props.data) {
      return this.noData();
    } else if (this.isEmptyData()) {
      return this.emptyDataMessage();
    } else {
      return this.funnelMoves();
    }
  }
});

module.exports = FunnelMovesTable;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/funnel-moves-table.jsx